<template>
  <div class="employeecreate">
    <FormaOkvir
      v-if="noviIzgled"
      ref="okvir"
      :greske="greskeVidljive"
      :upozorenja="validacija.upozorenja"
      :izmijenjena="izmijenjena"
      :redoslijed="redoslijed"
      :poruka="porukaServera"
    >
      <FormaTraka
        slot="traka"
        :naslov="naslovTrake"
        :podnaslov="podnaslovTrake"
        :inicijali="inicijali"
        :spremanje="spremanje"
        @spremi="spremiNovi"
        @odustani="odustani"
        @stari-obrazac="promijeniIzgled('stari')"
      >
        <FormaTabovi slot="tabovi" :tabovi="tabovi" />
      </FormaTraka>

      <div class="stupci">
        <div>
          <FormaKartica id="k-staz" naslov="Staž i mjesto rada" :kljucevi="stazKljucevi" :model="employee">
            <div class="podnaslov">Rad do dolaska u firmu</div>
            <div class="mreza c3">
              <FormaPolje ime="WorkYearsBefore" :label="oz('WorkYearsBefore')">
                <input type="text" class="n" v-model.number="employee.WorkYearsBefore" inputmode="numeric" />
              </FormaPolje>
              <FormaPolje ime="WorkMonthsBefore" :label="oz('WorkMonthsBefore')">
                <input type="text" class="n" v-model.number="employee.WorkMonthsBefore" inputmode="numeric" />
              </FormaPolje>
              <FormaPolje ime="WorkDaysBefore" :label="oz('WorkDaysBefore')">
                <input type="text" class="n" v-model.number="employee.WorkDaysBefore" inputmode="numeric" />
              </FormaPolje>
            </div>
            <div class="podnaslov">Mjesto rada</div>
            <div class="mreza">
              <FormaPolje class="sve" ime="WorkInCityCodeID" :label="oz('WorkInCityCodeID')" hint="šifra i naziv grada upisuju se automatski odabirom">
                <v-autocomplete
                  :items="cities"
                  v-model="selectCity"
                  item-text="CityName"
                  item-value="CityCode"
                  return-object
                  clearable
                  dense
                  outlined
                  hide-details
                ></v-autocomplete>
              </FormaPolje>
              <FormaPolje ime="WorkInCityCode" :label="oz('WorkInCityCode')">
                <input type="text" v-model="employee.WorkInCityCode" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="WorkInCityName" :label="oz('WorkInCityName')">
                <input type="text" v-model="employee.WorkInCityName" autocomplete="off" />
              </FormaPolje>
            </div>
          </FormaKartica>

          <FormaKartica id="k-odjeca" naslov="Radna odjeća" dodatak="osobne mjere" sklopiva :otvoreno.sync="otv.odjeca" :kljucevi="odjecaKljucevi" :model="employee">
            <div class="mreza">
              <FormaPolje ime="PersonalHeight" :label="oz('PersonalHeight')">
                <input type="text" v-model="employee.PersonalHeight" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="PersonalShoes" :label="oz('PersonalShoes')">
                <input type="text" v-model="employee.PersonalShoes" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="PersonalSizeUp" :label="oz('PersonalSizeUp')">
                <input type="text" v-model="employee.PersonalSizeUp" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="PersonalSizeDown" :label="oz('PersonalSizeDown')">
                <input type="text" v-model="employee.PersonalSizeDown" autocomplete="off" />
              </FormaPolje>
            </div>
          </FormaKartica>
        </div>

        <div>
          <FormaKartica id="k-zastita" naslov="Zaštita i status radnika" sklopiva :otvoreno.sync="otv.zastita" :kljucevi="zastitaKljucevi" :model="employee">
            <div class="podnaslov">Trudnoća i roditeljstvo</div>
            <div class="mreza">
              <FormaPolje ime="Pregnancy" :label="oz('Pregnancy')">
                <input type="text" v-model="employee.Pregnancy" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="Maternity" :label="oz('Maternity')">
                <input type="text" v-model="employee.Maternity" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="Breastfeeding" :label="oz('Breastfeeding')">
                <input type="text" v-model="employee.Breastfeeding" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="OnlyParent" :label="oz('OnlyParent')">
                <input type="text" v-model="employee.OnlyParent" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="AdoptionStatus" :label="oz('AdoptionStatus')">
                <input type="text" v-model="employee.AdoptionStatus" autocomplete="off" />
              </FormaPolje>
            </div>
            <div class="podnaslov">Radni uvjeti</div>
            <div class="mreza c1">
              <FormaPolje ime="ProfessionalIllnes" :label="oz('ProfessionalIllnes')">
                <input type="text" v-model="employee.ProfessionalIllnes" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="HurtOnWork" :label="oz('HurtOnWork')">
                <input type="text" v-model="employee.HurtOnWork" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="ProfessionalCantWork" :label="oz('ProfessionalCantWork')">
                <input type="text" v-model="employee.ProfessionalCantWork" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="ProfessionalLowerAbbilities" :label="oz('ProfessionalLowerAbbilities')">
                <input type="text" v-model="employee.ProfessionalLowerAbbilities" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="ProfessionalLoseWrokAbbility" :label="oz('ProfessionalLoseWrokAbbility')">
                <input type="text" v-model="employee.ProfessionalLoseWrokAbbility" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="DangerOfLosingProfAbbilityInjury" :label="oz('DangerOfLosingProfAbbilityInjury')">
                <input type="text" v-model="employee.DangerOfLosingProfAbbilityInjury" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="DangerOfHaveDisability" :label="oz('DangerOfHaveDisability')">
                <input type="text" v-model="employee.DangerOfHaveDisability" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="Disability" :label="oz('Disability')">
                <input type="text" v-model="employee.Disability" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="DisabilityPension" :label="oz('DisabilityPension')">
                <input type="text" v-model="employee.DisabilityPension" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="DisabilityWorkTIme" :label="oz('DisabilityWorkTIme')">
                <input type="text" v-model="employee.DisabilityWorkTIme" autocomplete="off" />
              </FormaPolje>
              <FormaPolje ime="WorkForOtherEmployee" :label="oz('WorkForOtherEmployee')">
                <input type="text" v-model="employee.WorkForOtherEmployee" autocomplete="off" />
              </FormaPolje>
            </div>
          </FormaKartica>
        </div>
      </div>
    </FormaOkvir>

    <template v-else>
    <h2>
      {{lang.AdditionalData}}
      </h2>
    <v-btn outlined color="primary" class="mb-2" @click="promijeniIzgled('novi')">Novi obrazac</v-btn>
    <v-container grid-list-md text-xs-center>
      <v-layout >

        <v-flex xs4 >
          <h3 class="text-xs-left mb-2">
            {{lang.WorkBefore}}
          </h3>
    
        <v-row>
          <v-col cols="12" sm="2" md="2" xs="2" lg="2" xl="2" >
            <v-text-field
              :label="lang.WorkYearsBefore"
              v-model.number="employee.WorkYearsBefore"
            ></v-text-field>
          </v-col>
           <v-col cols="12" sm="2" md="2" xs="2" lg="2" xl="2" >
            <v-text-field
              :label="lang.WorkMonthsBefore"
              v-model.number="employee.WorkMonthsBefore"
            ></v-text-field>
          </v-col>
           <v-col cols="12" sm="2" md="2" xs="2" lg="2" xl="2" >
            <v-text-field
              :label="lang.WorkDaysBefore"
              v-model.number="employee.WorkDaysBefore"
            ></v-text-field>
          </v-col>
        </v-row>

         <v-row>
            <v-col cols="12" xs="12" sm="12" md="6" lg="3" xl="3" class="pr-2">
            <v-autocomplete
                :items="cities"
                v-model="selectCity"
                :label="lang.CityTaxId"
                item-text="CityName"
                item-value="CityCode"
                return-object
                persistent-hint
                clearable
                dense
              ></v-autocomplete> 
          </v-col>
           <v-col cols="12" xs="6" sm="6" md="6" lg="2" xl="2" >
            <v-text-field
              :label="lang.WorkInCityCode"
              v-model="employee.WorkInCityCode"
            ></v-text-field>
          </v-col>
           <v-col cols="12" xs="6" sm="6" md="6" lg="4" xl="4" >
            <v-text-field
              :label="lang.WorkInCityName"
              v-model="employee.WorkInCityName"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3" >
            <v-text-field
              :label="lang.Pregnancy"
              v-model="employee.Pregnancy"
            ></v-text-field>
          </v-col>
           <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3" >
            <v-text-field
              :label="lang.Maternity"
              v-model="employee.Maternity"
            ></v-text-field>
          </v-col>
           <v-col cols="12" sm="4" md="4" xs="4" lg="4" xl="4" >
            <v-text-field
              :label="lang.Breastfeeding"
              v-model="employee.Breastfeeding"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6" >
            <v-text-field
              :label="lang.OnlyParent"
              v-model="employee.OnlyParent"
            ></v-text-field>
          </v-col>
           <v-col cols="12" sm="4" md="4" xs="4" lg="4" xl="4" >
            <v-text-field
              :label="lang.AdoptionStatus"
              v-model="employee.AdoptionStatus"
            ></v-text-field>
          </v-col>
        </v-row>                  

          <br>
          <div class="danger-alert" v-html="error" />
          <br>

          <v-btn
            dark
            class="blue mr-2"
            @click="register">
            {{langC.Save}}
          </v-btn>
          <v-btn
            color="green"
            @click="employeeList">
            {{langC.Back}}
          </v-btn>
        </v-flex>


        <v-flex xs4 >
          <h3 class="text-xs-left">
            {{lang.WorkEnvironment}}
          </h3>

          <v-text-field
            :label="lang.ProfessionalIllnes"
            v-model="employee.ProfessionalIllnes"
          ></v-text-field>

          <v-text-field
            :label="lang.HurtOnWork"
            v-model="employee.HurtOnWork"
          ></v-text-field>      

          <v-text-field
            :label="lang.ProfessionalCantWork"
            v-model="employee.ProfessionalCantWork"
          ></v-text-field>      

          <v-text-field
            :label="lang.ProfessionalLowerAbbilities"
            v-model="employee.ProfessionalLowerAbbilities"
          ></v-text-field>      

          <v-text-field
            label="Professional Lose Wrok Abbility:"
            v-model="employee.ProfessionalLoseWrokAbbility"
          ></v-text-field>
      
          <v-text-field
            :label="lang.DangerOfLosingProfAbbilityInjury"
            v-model="employee.DangerOfLosingProfAbbilityInjury"
          ></v-text-field>
      
          <v-text-field
            :label="lang.DangerOfHaveDisability"
            v-model="employee.DangerOfHaveDisability"
          ></v-text-field>     

          <v-text-field
            :label="lang.Disability"
            v-model="employee.Disability"
          ></v-text-field>       

          <v-text-field
            :label="lang.DisabilityPension"
            v-model="employee.DisabilityPension"
          ></v-text-field>

          <v-text-field
            :label="lang.DisabilityWorkTIme"
            v-model="employee.DisabilityWorkTIme"
          ></v-text-field>         

          <v-text-field
            :label="lang.WorkForOtherEmployee"
            v-model="employee.WorkForOtherEmployee"
          ></v-text-field>           

        </v-flex>

        <v-flex xs2 >
          <h3 class="text-xs-left">
            {{lang.PersonalData}}         
          </h3>

         <v-text-field
            :label="lang.PersonalHeight"
            v-model="employee.PersonalHeight"
          ></v-text-field>

         <v-text-field
            :label="lang.PersonalSizeUp"
            v-model="employee.PersonalSizeUp"
          ></v-text-field>

         <v-text-field
            :label="lang.PersonalSizeDown"
            v-model="employee.PersonalSizeDown"
          ></v-text-field>

         <v-text-field
            :label="lang.PersonalShoes"
            v-model="employee.PersonalShoes"
          ></v-text-field>                             

        </v-flex>

      </v-layout>
    </v-container>
    </template>

  </div>
</template>

<script>
import EmployeeService from '@/services/EmployeeService'
import CityService from '@/services/CityService'
import langEn from './empDescEn'
import langHr from './empDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import FormaOkvir from './forma/FormaOkvir'
import FormaTraka from './forma/FormaTraka'
import FormaTabovi from './forma/FormaTabovi'
import FormaKartica from './forma/FormaKartica'
import FormaPolje from './forma/FormaPolje'
import {
  citajIzgled, spremiIzgled, kloniraj, izmijenjenaPolja, validiraj, cistaOznaka, porukaIzGreske
} from './forma/formaLogika'

const STAZ = ['WorkYearsBefore', 'WorkMonthsBefore', 'WorkDaysBefore', 'WorkInCityCodeID', 'WorkInCityCode', 'WorkInCityName']
const RODITELJSTVO = ['Pregnancy', 'Maternity', 'Breastfeeding', 'OnlyParent', 'AdoptionStatus']
const UVJETI = ['ProfessionalIllnes', 'HurtOnWork', 'ProfessionalCantWork', 'ProfessionalLowerAbbilities', 'ProfessionalLoseWrokAbbility',
  'DangerOfLosingProfAbbilityInjury', 'DangerOfHaveDisability', 'Disability', 'DisabilityPension', 'DisabilityWorkTIme', 'WorkForOtherEmployee']
const ZASTITA = RODITELJSTVO.concat(UVJETI)
const ODJECA = ['PersonalHeight', 'PersonalSizeUp', 'PersonalSizeDown', 'PersonalShoes']
const SVA_POLJA = STAZ.concat(ZASTITA, ODJECA) // 26 polja + šifra grada (ID)
const brojUpozorenje = (v) => (v === '' || v === null || v === undefined || (typeof v === 'number' && v >= 0) ? null : 'Očekuje se broj (0 ili više)')

export default {
  name: 'employeedit2',
  components: { FormaOkvir, FormaTraka, FormaTabovi, FormaKartica, FormaPolje },
  data () {
    return {
      noviIzgled: citajIzgled('employeeEdit2Izgled') === 'novi',
      izvornik: null,
      pokusaj: false,
      spremanje: false,
      otv: { zastita: true, odjeca: true },
      stazKljucevi: STAZ,
      zastitaKljucevi: ZASTITA,
      odjecaKljucevi: ODJECA,
      redoslijed: STAZ.concat(ZASTITA, ODJECA),
      lang: {},
      langC: {},
      menu: false,
      modal: false,
      msg: '',
      newEmployee: {},
      employee: { },
      required: (value) => !!value || 'Required.',
      error: '',
      cities: [],
      selectCity: {},
    }
  },
  async mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    if (this.$store.state.employeeid) {
      try {
        const {data} = await CityService.index()
        if (data && data.cities !== undefined){
          this.cities = data.cities
        }
        const dbEmployee = await EmployeeService.show(this.$store.state.employeeid)
        // console.log(dbEmployee.data.employee)
        this.employee = dbEmployee.data.employee
        if (this.employee.WorkInCityCodeID) {
          this.selectCity = this.cities.find( city => city.id === this.employee.WorkInCityCodeID)
        }
      } catch (error) {
        this.error = error
      }
    }
    await this.$nextTick() // pusti da watcher gradova upiše šifru/naziv prije snimanja izvornika
    this.izvornik = kloniraj(this.employee)
  },
  methods: {
    // ---- novi obrazac ----
    oz (k) {
      return cistaOznaka(this.lang[k])
    },
    promijeniIzgled (izgled) {
      this.noviIzgled = izgled === 'novi'
      spremiIzgled('employeeEdit2Izgled', izgled)
    },
    odustani () {
      if (this.izmijenjena.length && !window.confirm('Ima nespremljenih izmjena. Odustati bez spremanja?')) return
      this.employeeList()
    },
    async spremiNovi () {
      this.pokusaj = true
      this.error = ''
      await this.$nextTick()
      if (Object.keys(this.validacija.greske).length) {
        if (this.$refs.okvir) this.$refs.okvir.skociNaPrvu()
        return
      }
      this.spremanje = true
      try {
        await this.register()
      } finally {
        this.spremanje = false
      }
    },
    // ---- postojeće metode (stari obrazac) ----
    async register () {
      try {
        if (this.$store.state.user.email) {
          this.employee.email = this.$store.state.user.email
          this.employee.LastUpdateBy = this.$store.state.user.email
        }
        await EmployeeService.put(this.employee)
        this.$router.push({
          name: 'employeeview'
        })
      } catch (error) {
        this.error = porukaIzGreske(error)
      }
    },
    async employeeList () {
      try {
        await this.$router.push({
          name: 'employeeview'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    }
  },
  computed: {
    izmijenjena () {
      return izmijenjenaPolja(this.izvornik, this.employee, SVA_POLJA)
    },
    validacija () {
      return validiraj(this.employee, {
        upozorenja: {
          WorkYearsBefore: brojUpozorenje,
          WorkMonthsBefore: (v) => brojUpozorenje(v) || (typeof v === 'number' && v > 11 ? 'Mjeseci su obično 0–11' : null),
          WorkDaysBefore: brojUpozorenje
        }
      })
    },
    greskeVidljive () {
      return this.validacija.greske
    },
    porukaServera () {
      return this.error ? porukaIzGreske(this.error) : ''
    },
    naslovTrake () {
      const ime = ((this.employee.First || '') + ' ' + (this.employee.Last || '')).trim()
      return ime || this.oz('AdditionalData')
    },
    podnaslovTrake () {
      return ['Uređivanje dodatnih podataka', this.employee.VatID ? 'OIB ' + this.employee.VatID : '', this.employee.hashtag || ''].filter(x => x).join(' · ')
    },
    inicijali () {
      const a = String(this.employee.First || '').trim().charAt(0)
      const b = String(this.employee.Last || '').trim().charAt(0)
      return (a + b).toUpperCase() || '+'
    },
    tabovi () {
      return [
        { id: 'k-staz', naslov: 'Staž i mjesto rada', kljucevi: STAZ },
        { id: 'k-zastita', naslov: 'Zaštita i status', kljucevi: ZASTITA },
        { id: 'k-odjeca', naslov: 'Radna odjeća', kljucevi: ODJECA }
      ]
    }
  },
  watch: {
     'selectCity' () {
      if (this.selectCity) {
        this.employee.WorkInCityCodeID = this.selectCity.id
        this.employee.WorkInCityCode = this.selectCity.CityCode
        this.employee.WorkInCityName = this.selectCity.CityName
      }
      if (!this.selectCity) {
        this.employee.WorkInCityCode = null
        this.employee.WorkInCityName = null
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
